import {defineMessages} from "react-intl";

export const validationMessages = defineMessages({
  contactMethodRequired: {
    id: "validation.contact.method.required",
    defaultMessage: "Provide email or phone number",
    description: "Validation message shown when both email and phone number are missing",
  },
  invalidEmail: {
    id: "validation.email.invalid",
    defaultMessage: "Enter valid email address",
    description: "Validation message shown when email input is not valid",
  },
  required: {
    id: "validation.required",
    defaultMessage: "{fieldLabel} is required",
    description: "Generic validation message shown when required field is empty",
  },
});

export const commonMessages = defineMessages({});
